import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StartMyMultiFactorEnrollmentMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StartMyMultiFactorEnrollmentMutation = { __typename?: 'Mutation', startMyMultiFactorEnrollment: { __typename?: 'StartMyMultiFactorEnrollmentPayload', enrollment?: { __typename?: 'MultiFactorEnrollmentStart', secretBase32Encoded: string, otpAuthUri: string, issuer: string, accountName: string, algorithm: string, digits: number, periodSeconds: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteMyMultiFactorEnrollmentMutationVariables = Types.Exact<{
  input: Types.CompleteMyMultiFactorEnrollmentInput;
}>;


export type CompleteMyMultiFactorEnrollmentMutation = { __typename?: 'Mutation', completeMyMultiFactorEnrollment: { __typename?: 'CompleteMyMultiFactorEnrollmentPayload', recoveryCodes?: Array<string> | null, status?: { __typename?: 'MyMultiFactorStatus', applicationId: string, enabled: boolean, methods: Array<string>, mfaEnrollmentRequired: boolean, mfaEnrollmentBlocking: boolean, graceDeadline?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DisableMyMultiFactorMutationVariables = Types.Exact<{
  input: Types.DisableMyMultiFactorInput;
}>;


export type DisableMyMultiFactorMutation = { __typename?: 'Mutation', disableMyMultiFactor: { __typename?: 'MyMultiFactorStatusPayload', status?: { __typename?: 'MyMultiFactorStatus', applicationId: string, enabled: boolean, methods: Array<string>, mfaEnrollmentRequired: boolean, mfaEnrollmentBlocking: boolean, graceDeadline?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RegenerateMyMultiFactorRecoveryCodesMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RegenerateMyMultiFactorRecoveryCodesMutation = { __typename?: 'Mutation', regenerateMyMultiFactorRecoveryCodes: { __typename?: 'MultiFactorRecoveryCodesPayload', recoveryCodes?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantMultiFactorRequirementMutationVariables = Types.Exact<{
  input: Types.SetTenantMultiFactorRequirementInput;
}>;


export type SetTenantMultiFactorRequirementMutation = { __typename?: 'Mutation', setTenantMultiFactorRequirement: { __typename?: 'TenantMultiFactorPolicyPayload', policy?: { __typename?: 'TenantMultiFactorPolicy', applicationId: string, requireMfa: boolean, graceWindowDays?: number | null, enabledAt?: Types.TDateISO | null, graceDeadline?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const StartMyMultiFactorEnrollmentDocument = new TypedDocumentString(`
    mutation StartMyMultiFactorEnrollment {
  startMyMultiFactorEnrollment {
    enrollment {
      ...MultiFactorEnrollmentStart
    }
    errors {
      code
      message
    }
  }
}
    fragment MultiFactorEnrollmentStart on MultiFactorEnrollmentStart {
  secretBase32Encoded
  otpAuthUri
  issuer
  accountName
  algorithm
  digits
  periodSeconds
}`);
export const CompleteMyMultiFactorEnrollmentDocument = new TypedDocumentString(`
    mutation CompleteMyMultiFactorEnrollment($input: CompleteMyMultiFactorEnrollmentInput!) {
  completeMyMultiFactorEnrollment(input: $input) {
    status {
      ...MyMultiFactorStatus
    }
    recoveryCodes
    errors {
      code
      message
    }
  }
}
    fragment MyMultiFactorStatus on MyMultiFactorStatus {
  applicationId
  enabled
  methods
  mfaEnrollmentRequired
  mfaEnrollmentBlocking
  graceDeadline
}`);
export const DisableMyMultiFactorDocument = new TypedDocumentString(`
    mutation DisableMyMultiFactor($input: DisableMyMultiFactorInput!) {
  disableMyMultiFactor(input: $input) {
    status {
      ...MyMultiFactorStatus
    }
    errors {
      code
      message
    }
  }
}
    fragment MyMultiFactorStatus on MyMultiFactorStatus {
  applicationId
  enabled
  methods
  mfaEnrollmentRequired
  mfaEnrollmentBlocking
  graceDeadline
}`);
export const RegenerateMyMultiFactorRecoveryCodesDocument = new TypedDocumentString(`
    mutation RegenerateMyMultiFactorRecoveryCodes {
  regenerateMyMultiFactorRecoveryCodes {
    recoveryCodes
    errors {
      code
      message
    }
  }
}
    `);
export const SetTenantMultiFactorRequirementDocument = new TypedDocumentString(`
    mutation SetTenantMultiFactorRequirement($input: SetTenantMultiFactorRequirementInput!) {
  setTenantMultiFactorRequirement(input: $input) {
    policy {
      ...TenantMultiFactorPolicy
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantMultiFactorPolicy on TenantMultiFactorPolicy {
  applicationId
  requireMfa
  graceWindowDays
  enabledAt
  graceDeadline
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StartMyMultiFactorEnrollment: build.mutation<StartMyMultiFactorEnrollmentMutation, StartMyMultiFactorEnrollmentMutationVariables | void>({
      query: (variables) => ({ document: StartMyMultiFactorEnrollmentDocument, variables })
    }),
    CompleteMyMultiFactorEnrollment: build.mutation<CompleteMyMultiFactorEnrollmentMutation, CompleteMyMultiFactorEnrollmentMutationVariables>({
      query: (variables) => ({ document: CompleteMyMultiFactorEnrollmentDocument, variables })
    }),
    DisableMyMultiFactor: build.mutation<DisableMyMultiFactorMutation, DisableMyMultiFactorMutationVariables>({
      query: (variables) => ({ document: DisableMyMultiFactorDocument, variables })
    }),
    RegenerateMyMultiFactorRecoveryCodes: build.mutation<RegenerateMyMultiFactorRecoveryCodesMutation, RegenerateMyMultiFactorRecoveryCodesMutationVariables | void>({
      query: (variables) => ({ document: RegenerateMyMultiFactorRecoveryCodesDocument, variables })
    }),
    SetTenantMultiFactorRequirement: build.mutation<SetTenantMultiFactorRequirementMutation, SetTenantMultiFactorRequirementMutationVariables>({
      query: (variables) => ({ document: SetTenantMultiFactorRequirementDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStartMyMultiFactorEnrollmentMutation, useCompleteMyMultiFactorEnrollmentMutation, useDisableMyMultiFactorMutation, useRegenerateMyMultiFactorRecoveryCodesMutation, useSetTenantMultiFactorRequirementMutation } = injectedRtkApi;
